// MENU GSAP
import { gsap } from "gsap";
let menuOpen = false;

const tl = gsap.timeline({
    paused: true,
    defaults: { duration: 0.3, ease: "power1.inOut" }
});

tl.to(
    ".navigation-wrapper",
    { opacity: 1, visibility: 'visible' },
);

tl.fromTo(
    ".main-navigation__list .menu-item",
    { opacity: 0, y: "0.5em", stagger: 0.1 },
    { delay: 0.1, opacity: 1, y: "0em", stagger: 0.1 },
);

const tlBackdrop = gsap.timeline({
    paused: true,
    defaults: { duration: 0.3, ease: "power1.inOut" }
});

tlBackdrop.to(
    ".navigation-backdrop",
    { opacity: .8, visibility: 'visible' }
);

const navToggles = document.querySelectorAll('.js-toggle-menu');

for (let i = 0; i < navToggles.length; i++) {
    navToggles[i].addEventListener('click', function (event) {
        event.preventDefault();
        if (!menuOpen) {
            tl.timeScale(1.3).play();
            tlBackdrop.timeScale(1.3).play();
            menuOpen = true;
        } else {
            tl.timeScale(2).reverse();
            tlBackdrop.timeScale(2).reverse();
            menuOpen = false;
        }
    })
};

document.querySelector('.navigation-backdrop').addEventListener('click', function (event) {
    event.preventDefault();
    if (!menuOpen) {
        tl.timeScale(1.3).play();
        tlBackdrop.timeScale(1.3).play();
        menuOpen = true;
    } else {
        tl.timeScale(2).reverse();
        tlBackdrop.timeScale(2).reverse();
        menuOpen = false;
    }
});
